<template>
  <b-modal
    id="level-reward-form-modal"
    :title="`${reward ? 'Update' : 'Create New'} Reward`"
    hide-footer
    size="lg"
    no-close-on-backdrop
    @hidden="formData = LEVEL_REWARD_FORM_SNAPSHOT()"
    @shown="modalOpenHandler"
  >
    <b-form
      novalidate
      @submit.prevent="submitForm"
    >
      <validation-observer ref="formRef">
        <b-row>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Name En"
              rules="required"
            >
              <b-form-group
                label="Name En"
                label-for="team-reward-name-en"
              >
                <b-form-input
                  id="team-reward-name-en"
                  v-model="formData.name.en"
                  placeholder="Name En"
                  maxlength="25"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Name Ar"
              rules="required"
            >
              <b-form-group
                label="Name Ar"
                label-for="team-reward-name-ar"
              >
                <b-form-input
                  id="team-reward-name-ar"
                  v-model="formData.name.ar"
                  placeholder="Name Ar"
                  maxlength="25"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Description En"
              rules="required"
            >
              <b-form-group
                label="Description En"
                label-for="team-level-reward-description-en"
              >
                <b-form-textarea
                  id="team-level-reward-description-en"
                  v-model="formData.description.en"
                  placeholder="description En"
                  maxlength="25"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Description Ar"
              rules="required"
            >
              <b-form-group
                label="Description Ar"
                label-for="team-level-reward-description-ar"
              >
                <b-form-textarea
                  id="team-level-reward-description-ar"
                  v-model="formData.description.ar"
                  placeholder="description Ar"
                  maxlength="25"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <b-form-group label="Beneficiary">
              <b-form-radio-group
                id="beneficiary"
                v-model="formData.beneficiary"
                class="mb-1"
                :options="BENEFICIARY_OPTIONS"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Amount"
              rules="required"
            >
              <b-form-group
                label="Amount"
                label-for="reward-amount"
              >
                <b-form-input
                  id="reward-amount"
                  v-model.number="formData.configuration.amount"
                  placeholder="Amount"
                  type="number"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="12">
            <b-button
              type="submit"
              variant="primary"
              :disabled="submitting"
            >
              <b-spinner
                v-if="submitting"
                small
              />
              <span v-else>Save</span>
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BSpinner,
  BRow,
  BCol,
  BModal,
  BFormRadioGroup,
  BFormTextarea,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, maxValue } from '@validations'
import { ref } from '@vue/composition-api'
import { errorNotification } from '@/utils/toast-notifications'
import axiosIns from '@/libs/axios'

const BENEFICIARY_TYPES = {
  // ALL: 'ALL',
  LEADER: 'LEADER',
  MEMEBERS_ONLY: 'MEMBERS_ONLY',
}

const BENEFICIARY_OPTIONS = [
  // {
  //   text: 'All',
  //   value: BENEFICIARY_TYPES.ALL,
  // },
  {
    text: 'Leader',
    value: BENEFICIARY_TYPES.LEADER,
  },
  {
    text: 'Members only',
    value: BENEFICIARY_TYPES.MEMEBERS_ONLY,
  },
]

const LEVEL_REWARD_FORM_SNAPSHOT = () => JSON.parse(JSON.stringify({
  levelId: null,
  type: 'CREDIT_WALLET',
  beneficiary: BENEFICIARY_TYPES.LEADER,
  name: {
    ar: null,
    en: null,
  },
  description: {
    ar: null,
    en: null,
  },
  configuration: {
    amount: null,
  },
}))

export default {
  components: {
    BModal,
    ValidationObserver,
    ValidationProvider,
    BForm,
    BSpinner,
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BFormRadioGroup,
    BCol,
    BFormTextarea,
  },
  props: {
    reward: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const levelID = ctx.root.$route.params.id
    const submitting = ref(false)

    const formData = ref(LEVEL_REWARD_FORM_SNAPSHOT())

    const formRef = ref(null)

    const submitForm = async () => {
      const res = await formRef.value.validate()
      if (!res) return

      try {
        submitting.value = true
        if (props.reward) {
          await axiosIns.patch(`/teams/rewards/${props.reward.id}`, {
            ...formData.value,
            levelId: levelID,
          })
        } else {
          await axiosIns.post('/teams/rewards', {
            ...formData.value,
            levelId: levelID,
          })
        }
        ctx.root.$bvModal.hide('level-reward-form-modal')
        ctx.emit('refetch')
      } catch (err) {
        console.log(err?.response)
        errorNotification('An Error Occured')
      } finally {
        submitting.value = false
      }
    }

    const modalOpenHandler = () => {
      if (props.reward) {
        formData.value = JSON.parse(JSON.stringify(props.reward))
      }
    }

    return {
      maxValue,
      submitting,
      formRef,
      BENEFICIARY_TYPES,
      submitForm,
      BENEFICIARY_OPTIONS,
      formData,
      modalOpenHandler,
      LEVEL_REWARD_FORM_SNAPSHOT,
      required,
    }
  },
}
</script>

      <style></style>
